export default __webpack_public_path__ + "static/media/landingBackground3.da108da2.png";